import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { PIN_KEY } from '@web-mail/common/constant';
import styles from './pinHead.module.scss';
import { apiHolder } from 'api';
const storeApi = apiHolder.api.getDataStoreApi();
const Icon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: styles.icon },
        React.createElement("path", { d: "M14 11L14 5L12.75 5C12.3358 5 12 5.33579 12 5.75C12 5.88807 11.8881 6 11.75 6L10.6 6C10.2686 6 10 5.73137 10 5.4C10 4.07452 8.92548 3 7.6 3L6 3L6 13L7.6 13C8.92548 13 10 11.9255 10 10.6C10 10.2686 10.2686 10 10.6 10L11.75 10C11.8881 10 12 10.1119 12 10.25C12 10.6642 12.3358 11 12.75 11L14 11Z", stroke: "#3F465C", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M1 7.5C0.723857 7.5 0.5 7.72386 0.5 8C0.5 8.27614 0.723857 8.5 1 8.5V7.5ZM6 7.5H1V8.5H6V7.5Z", fill: "#3F465C" })));
};
const IconActive = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: styles.activeIcon },
        React.createElement("path", { d: "M14 11L14 5L12.75 5C12.3358 5 12 5.33579 12 5.75C12 5.88807 11.8881 6 11.75 6L10.6 6C10.2686 6 10 5.73137 10 5.4C10 4.07452 8.92548 3 7.6 3L6 3L6 13L7.6 13C8.92548 13 10 11.9255 10 10.6C10 10.2686 10.2686 10 10.6 10L11.75 10C11.8881 10 12 10.1119 12 10.25C12 10.6642 12.3358 11 12.75 11L14 11Z", stroke: "#4c6aff", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M1 7.5C0.723857 7.5 0.5 7.72386 0.5 8C0.5 8.27614 0.723857 8.5 1 8.5V7.5ZM6 7.5H1V8.5H6V7.5Z", fill: "#4c6aff" })));
};
const PinHead = props => {
    const [isPin, setIsPin] = useState2RM('fixedReadMailHeader');
    const [localIsPin, setLocalIsPin] = useState(isPin);
    useEffect(() => {
        setLocalIsPin(isPin);
    }, [isPin]);
    const handleOnClick = e => {
        e.stopPropagation();
        e.preventDefault();
        setLocalIsPin(!isPin);
        setTimeout(() => {
            setIsPin(!isPin);
        }, 100);
        try {
            storeApi.putSync(PIN_KEY, JSON.stringify(!isPin), { noneUserRelated: true });
        }
        catch (e) {
            console.error(e);
        }
        if (!isPin) {
            message.success({ content: '已固定信头区域', key: PIN_KEY });
        }
        else {
            message.success({ content: '已取消固定信头区域', key: PIN_KEY });
        }
    };
    return (React.createElement("div", { className: classnames(styles.pinHead, { [styles.isPin]: localIsPin }), "data-test-id": "readmail-pin-head-button", onClick: handleOnClick },
        React.createElement(Icon, null),
        React.createElement(IconActive, null)));
};
export default PinHead;
